import React, { useEffect, useImperativeHandle, useLayoutEffect, useRef, useState } from "react";
import { Form, Formik } from "formik";

import {
  FormInput,
  FormDateSelector,
  FormSelector,
  FormCheckbox,
} from "../FormElements/index";
import { Button } from "../Elements";
import { useDispatch, useSelector } from "react-redux";
import commonNetwork from "../../../common/api/commonNetwork";
import { toast } from "react-toastify";
import { getIntegrationList, } from "../../../store/slices/IntegrationSlice";
import { TbDots } from "react-icons/tb";
import { customerSelectFrom, postMessageTypes } from "../../../constants/postMessageFileds";
import FormFiltersShortList from "../FormElements/FormFiltersShortList";
import FormObserver from "../FormElements/FormObserver";
import { clearOrderReportCustomer } from "../../../store/slices/orderReportSlice";
import { updateIsResetForm } from "../../../store/slices/formHelperSlice";
import { postWebViewMessage } from "../../../common/helpers/messageHelper";
import { isLogoAppProject } from "../../../common/helpers/globalHelpers";
import { getSelectedValueFromId } from "../../../common/helpers/selectBoxHelper";
import { buttonTexts } from "../../../constants/texts/buttonTexts";


const initialValues = {
  dateRange: {
    startDate: null,
    endDate: null,
  },
  paymentProvider: 0,
  isSyncOrders: false,
  customerName: ""
}

const Filters = React.forwardRef(({ isOpen, setFiltersIsOpen, page, pageSize, setRequestParameters }, ref) => {


  useImperativeHandle(ref, () => ({

    submitform() {
      formref.current.submitForm();
    },
    getFormValues() {
      return formref.current.values;
    }
  }));


  const { selectedCustomer } = useSelector((state) => state.orderReport);
  const formref = useRef();
  const dateRangeRef = useRef();
  const isFirstRequest = useRef(true);


  const customerNameInputRef = useRef();
  const dispatch = useDispatch();

  const [activePosList, setActivePosList] = useState([]);
  const [formValues, setFormValues] = useState(initialValues);

  useLayoutEffect(() => {
    selectActivePos();
  }, []);

  useEffect(() => {

    if (selectedCustomer.code) {
      customerNameInputRef.current.setValue(selectedCustomer.code);
      dispatch(clearOrderReportCustomer());
    }


  }, [selectedCustomer]);
  useEffect(() => {
    selectIntegrationList();
  }, []);

  const selectIntegrationList = () => {
    if (formref && formref.current) {
      formref.current.submitForm();
    }
  }

  const selectActivePos = async () => {

    const data = await commonNetwork.get("/virtualpos/actives");
    var poslist = [];
    if (data.isSuccess) {
      var res = data.data;
      poslist.push({
        value: 0,
        label: "Tümü",
      });
      for (let i = 0; i < res.length; i++) {
        const element = res[i];
        poslist.push({
          value: element.vpid,
          label: element.vpdisplayname,
        });
      }
      setActivePosList(poslist);

    } else {
      toast.error(data.errorMessage);
    }
  }
  function submitform() {
    formref.current.submitForm();
  }

  const onSubmit = async (values, actions) => {

    var start = values.dateRange.startDate;
    var end = values.dateRange.endDate;
    var startDate = "";
    var endDate = "";
    if (start) {
      startDate = start.getDate() + "/" + (start.getMonth() + 1) + "/" + start.getFullYear();
    }
    if (end) {
      endDate = end.getDate() + "/" + (end.getMonth() + 1) + "/" + end.getFullYear();
    }

    const parameters = {
      timeStart: startDate,
      timeEnd: endDate,
      paymentProvider: values.paymentProvider > 0 ? values.paymentProvider : "",
      isSync: values.isSyncOrders,
      customerName: values.customerName,
      pageNumber: 1,
      pageSize: pageSize
    };

    setRequestParameters(parameters);
    dispatch(getIntegrationList( parameters ));

    if (isFirstRequest.current) {
      isFirstRequest.current = false;
    } else {
      setFiltersIsOpen(false);
    }

  };

  const openCustomerForm = () => {
    var callbackParameters = {
      customerSelectFrom: customerSelectFrom.fromOrderReport
    }

    var messageBody = { requestType: postMessageTypes.getCustomerInfo, requestBody: "", callbackParameters: JSON.stringify(callbackParameters) };
    postWebViewMessage(JSON.stringify(messageBody));
  }


  const fields = [
    { key: "customerName", label: "Cari Hesap Ünvan", type: "text" },
    { key: "isSyncOrders", label: "Aktarılan Ödemeleri Getir", type: "boolean" },

    { key: "dateRange", label: "Tarih Aralığı", type: "object", datatype: "daterange" },
    {
      key: "paymentProvider",
      label: "Ödeme Altyapısı",
      type: "select",
      options: activePosList,
    },
  ];

  const resetDateRanges = (value) => {
    var keys = Object.keys(value);

    if (keys && keys.length > 0) {
      if (keys[0] == "dateRange") {
        dateRangeRef.current.resetForm();
      }
    }
  }

  const onUpdate = (value) => {
    setFormValues(Object.assign(formValues, value));
    resetDateRanges(value);
    submitform();
  };
  const clearFilters = () => {
    formref.current.resetForm();

    dispatch(updateIsResetForm(true));
    setTimeout(() => {
      dispatch(updateIsResetForm(false));
    }, 1000);
    submitform();
  };
  return (
    <Formik
      innerRef={formref}
      initialValues={initialValues}
      onSubmit={onSubmit}
    >
      {({
        values,
        touched,
        dirty,
        errors,
        handleChange,
        handleBlur,
        handleSubmit,
        handleReset,
        setFieldValue,
        setFieldTouched,
        isSubmitting,
      }) => (
        <Form>
          <FormObserver
            watch={(val) => {
              setFormValues(val);
            }}
          />
          <div className={`mt-3 mx-4 mb-3 px-4 py-2 bg-white shadow-md rounded-md ${!isOpen ? "hidden" : ""}`}>
            <div className="grid grid-cols-1 gap-4 sm:gap-3 lg:grid-cols-3 xl:grid-cols-3 ">
              {/* <div className="mt-3">
                <div className="flex flex-col justify-start px-2">
                  
                </div> */}
              <div className="flex flex-col justify-start px-0">
                <div className="mt-1">
                  <FormInput
                    label="Cari Hesap Ünvan"
                    name="customerName"
                    type="text"
                    rightIcon={isLogoAppProject() &&
                      <TbDots
                        onClick={openCustomerForm}
                        className="sm:block h-6 w-6 text-black hidden cursor-pointer "
                        aria-hidden="true"
                        color="#0090FF"
                      />
                    }
                  />
                </div>
                <div className="mt-2">
                  <FormCheckbox
                    label={"Aktarılan Ödemeleri Getir"}
                    name="isSyncOrders"
                    type="checkbox"
                    id="isSyncOrders"
                    onChange={setFieldValue}
                    value={values.isSyncOrders}
                  />
                </div>
              </div>

              <div className="flex flex-col justify-start px-0">
                <div className="mt-1">
                  <FormDateSelector
                    label="Tarih Aralığı"
                    name="dateRange"
                    type="range"
                    ref={dateRangeRef}
                    nullable
                  />
                </div>
              </div>

              <div className="flex flex-col justify-start px-0">
                <div className="mt-1">
                  <FormSelector
                    options={activePosList}
                    name="paymentProvider"
                    placeholder="Tümü"
                    label="Ödeme Altyapısı"
                    onChange={setFieldValue}
                    onBlur={setFieldTouched}
                    error={errors.paymentProvider}
                    touched={touched.paymentProvider}
                    value={getSelectedValueFromId(values.paymentProvider, activePosList)}
                  />
                </div>
              </div>
            </div>
            <div className="flex justify-end mt-2 mr-0">
              <Button
                type="button"
                color="gray"
                hover="gray"
                size="xs"
                className="mr-3"
                callback={clearFilters}
              >
                <img src="/icons/delete-blue.svg" alt="deleteFilter" />
                <span className='ml-3'>{buttonTexts.filterClear}</span>
              </Button>
              <Button type="submit" color="primary" hover="primary" size="xs">
                <img src="/icons/prepare-white.svg" alt="prepare" />
                <span className='ml-3 mr-3'>{buttonTexts.filterSubmit}</span>
              </Button>
            </div>
          </div>
          <div
            className={`m-4 px-4 py-3 bg-white shadow-md rounded-md ${isOpen ? "hidden" : ""
              }`}
          >
            <FormFiltersShortList
              formValues={{ ...values }}
              fields={fields}
              initialValues={initialValues}
              callback={(val) => onUpdate(val)}
              clearFilter={() => {
                clearFilters()
                submitform();
              }}

            />
          </div>
        </Form>
      )}
    </Formik>
  );
})

export default Filters;